import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { FormGroupType } from '@app/core/utils/formgroup-type';
import { CreateMeteringPointCommand, UpdateMeteringPointCommand } from '@app/api/dmc';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';

@Component({
  selector: 'app-meteringpoint-form-creation-details',
  imports: [
    ReactiveFormsModule,
    GuideCardComponent,
    TranslatePipe,
    InputGroupComponent,
    LabelDirective,
    InputDateDirective
  ],
  templateUrl: './meteringpoint-form-creation-details.component.html',
  styleUrl: './meteringpoint-form-creation-details.component.css'
})
export class MeteringpointFormCreationDetailsComponent {
  @Input() public form!: FormGroupType<CreateMeteringPointCommand | UpdateMeteringPointCommand>;

  @Input() public fullWidth: boolean = true;

}
